import {
    KUBE_NODES_REQUEST_GET,
    KUBE_NODES_RESPONSE_GET_SUCCESS,
    KUBE_NODES_RESPONSE_GET_FAIL,

  } from "../../../constants/maintenance/systemHealth/kubeNodesConstants";
  
  export const kubeNodesShReducer = (state = { kubeNodes: {} }, action) => {
    switch (action.type) {
      case KUBE_NODES_REQUEST_GET:
        return {
          ...state,
          loading: true,
        };
      case KUBE_NODES_RESPONSE_GET_SUCCESS:
        return {
          ...state,
          loading: false,
          kubeNodes: action.payload,
        };
      case KUBE_NODES_RESPONSE_GET_FAIL:
        return {
          ...state,
          loading: false,
          error: action.payload,
        };
      default:
        return state;
    }
  };
  